import type { DialogRef } from '@myosh/odin-components';
import clsx from 'clsx';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../../record/record-menu.component';
import type { MenuComponentProps } from '../../record/record-menu.component';
import GroupAuditView from './group-audit-view.component';

interface GroupMenuProps {
  groupTitle: string;
  groupId: number;
  fullScreen?: boolean;
}

const GroupMenu = ({ groupTitle, groupId, fullScreen = false }: GroupMenuProps) => {
  const { t } = useTranslation();

  const auditModalReference = useRef<DialogRef>(null);

  const onAuditButtonClicked = () => {
    if (auditModalReference.current) {
      auditModalReference.current.show();
    }
  };

  const actionDropdownItemStyle = clsx({
    'text-sm flex items-center whitespace-nowrap px-2 py-1 leading-5 hover:bg-primary-4 cursor-pointer': !fullScreen,
  });

  const menuStyle = clsx({
    'z-30 absolute right-0 top-9 hidden w-48 flex-col bg-mono-1 py-1 shadow group-hover:flex': !fullScreen,
    flex: fullScreen,
  });

  const menus: MenuComponentProps[] = [
    {
      title: t('audit-log'),
      className: actionDropdownItemStyle,
      onClick: onAuditButtonClicked,
      icon: 'Clock',
    },
  ];
  return (
    <div className={menuStyle}>
      {menus.map((menu) => {
        return <MenuItem key={menu.title} menu={menu} fullScreenMode={fullScreen} />;
      })}
      <GroupAuditView
        ref={auditModalReference}
        header={`${t('audit-log')} - ${t('group')} - ${groupTitle}`}
        groupId={groupId}
      />
    </div>
  );
};

export default GroupMenu;
